export default __webpack_public_path__ + "static/4-4--c3ac5e2e32f294e472669792cb2e259f.png";